import React from 'react'
const CustomerHomeConfig = require('TENANT_CONFIG').customerHome

export const CustomerIDDisplay = (props) => {
  const { customer: { id } = {}, t} = props
  const supportText = !!t('support_link') ? <a href={t('support_link')}> Contact Us </a> : `Call ${t('support_number')}`

  if(!id || CustomerHomeConfig.hideFooter) return null
  return(
    <span styleName="intro__subhead">Customer ID: {id} | Questions? We can help.{supportText}</span>
  )
}
